module.exports = __webpack_public_path__ + "static/media/angieveguilla-15.5be57a91.jpg";